import React from 'react';
import { Link } from 'react-router-dom';

import { Col } from 'reactstrap';

import { Image } from '../../../AbstractElements';
import { dynamicImage } from '../../../Utils';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/Store';
import { setSideBarToggle } from '../../../store/reducers/Layout/LayoutReducer';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { Href } from '../../../Utils/Constants';
import useAuth from '../../../Hooks/useAuth';

export default function HorizontalLogo() {
   const dispatch = useDispatch();
   const { isLoggedIn } = useAuth();

   const { sideBarToggle } = useSelector((state: RootState) => state.layout);

   const handleSidebarToggle = () => {
      dispatch(setSideBarToggle(!sideBarToggle));
   };

   return (
      <Col xs="auto" className="logo-wrapper d-flex align-items-center">
         <Link
            to={
               isLoggedIn
                  ? `${process.env.PUBLIC_URL}/dashboard`
                  : `${process.env.PUBLIC_URL}/`
            }
         >
            <Image
               className="light-logo img-fluid rounded-circle"
               src={dynamicImage(`logo/logo.jpg`)}
               alt="logo"
               style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  marginLeft: '75px',
               }}
            />
            <Image
               className="dark-logo img-fluid rounded-circle"
               src={dynamicImage(`logo/logo.jpg`)}
               alt="logo"
               style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  marginLeft: '75px',
               }}
            />
         </Link>
         <a
            className="close-btn toggle-sidebar"
            href={Href}
            onClick={handleSidebarToggle}
         >
            <SvgIcon className="svg-color" iconId="Category" />
         </a>
      </Col>
   );
}
